export const SET_DATA = 'favorites/SET_DATA'
export const SET_IS_FETCHING = 'favorites/SET_IS_FETCHING'
